import React from 'react';
import { Theme } from '../../../../stores/types/themes';
import Icon, { COLORS, ICONS } from '../../../general-components/icon';
import classNames from 'classnames';
import { GreenroomState } from '../../../../stores/types/types';
import { useSelector } from 'react-redux';
import { THEME_FILTER } from '../../../../stores/reducers/themes';

interface Props {
	theme: Theme,
	onEdit: (theme: Theme) => void,
	onDelete: (theme: Theme) => void,
	onSelect: (theme: Partial<Theme>) => void,
	isSelected: boolean;
	uniqueId: string;
	isForShotEditorModal?: boolean;
}

export default function ThemeCard(props: Props) {
	const attachedThemes = useSelector((s: GreenroomState) => s.ThemesReducer.attachedThemes);
	const themeFilter = useSelector((s: GreenroomState) => s.ThemesReducer.themeFilter);
	const {id, name, colors} = props.theme;

	const isSelected = React.useMemo(() => {
		if (attachedThemes && props.uniqueId in attachedThemes) {
			return attachedThemes[props.uniqueId] === id;
		} else {
			return !!props.isSelected;
		}
	}, [props.uniqueId, attachedThemes, props.isSelected, id]);

	const select = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		if (isSelected) return; // don't re-apply the theme if it is already selected
		props.onSelect(props.theme)
	}
	const edit = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		props.onEdit(props.theme)
	}
	const deleteTheme = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
		props.onDelete(props.theme)
	}
	
	return (<div 
			onClick={select}
			className={classNames('theme-card justify-content-space-between', {
				selected: isSelected
			})}
		>
			<div className='margin-right-auto bl-font-s1'>{name}</div>
			<div className='flex'>
				{colors.map((hex, index) => index > 2 ? null : <div 
					key={`${hex}+${index}`}
					className={classNames('theme-card-swatch', { 'shot-modal': props.isForShotEditorModal })}
					style={{backgroundColor: hex}}/>
				)}
				{!props.isForShotEditorModal && (
					<div className='theme-card-edit-hover flex'>
						{themeFilter !== THEME_FILTER.CUSTOM ? null 
							: <div className='edit-button corner-round-massive margin-right-extra-small' onClick={deleteTheme}>
								<Icon name={ICONS.TRASH} size={12} color={COLORS.WHITE}/>
							</div>}
						<div className='edit-button corner-round-massive' onClick={edit}>
							<Icon name={ICONS.EDIT} size={12} color={COLORS.WHITE}/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
